import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const LoginPage = () => {
  const [username, setUsername] = useState('Admin');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login, loading, company } = useContext(AuthContext);
  const navigate = useNavigate();

  const compName = company?.Company_Name || company?.Comapny_Name || 'Hari Ganga Fish Syndicate';
  const compAddress = company?.Address || company?.Comapny_Address || 'Sakhar Koliwada, Alibag, Raigad';
  const compContact = company?.Contact_no || company?.Company_Mobile || '9881914831';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!username || !password) {
      setError('Please enter both username and password.');
      return;
    }

    const res = await login(username, password);
    if (res.success) {
      navigate('/dashboard');
    } else {
      setError(res.message);
    }
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center min-vh-100 bg-dark p-3"
      style={{
        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f766e 100%)'
      }}
    >
      <div className="card border-0 shadow-lg p-3 p-md-4 rounded-4" style={{ maxWidth: '460px', width: '100%' }}>
        <div className="card-body text-center p-2 p-md-3">
          {/* COMPANY HEADER BADGE */}
          <div className="mb-4">
            <div className="bg-primary bg-gradient text-white d-inline-flex p-3 rounded-circle shadow mb-2">
              <i className="bi bi-building fs-1"></i>
            </div>
            <h3 className="fw-extrabold text-dark mb-1 text-uppercase fs-4" style={{ letterSpacing: '0.02em' }}>
              {compName}
            </h3>
            <div className="badge bg-primary bg-opacity-10 text-primary fw-semibold px-3 py-1 rounded-pill mb-2">
              <i className="bi bi-geo-alt-fill me-1"></i> {compAddress}
            </div>
            <div>
              <span className="badge bg-success bg-opacity-10 text-success fw-bold px-3 py-1 rounded-pill small">
                <i className="bi bi-whatsapp me-1"></i> संम्पर्क: {compContact}
              </span>
            </div>
          </div>

          {error && (
            <div className="alert alert-danger py-2 small" role="alert">
              <i className="bi bi-exclamation-triangle-fill me-2"></i>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="text-start">
            <div className="mb-3">
              <label className="form-label fw-semibold small text-uppercase text-secondary">Username</label>
              <div className="input-group">
                <span className="input-group-text bg-light text-secondary">
                  <i className="bi bi-person"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="mb-4">
              <label className="form-label fw-semibold small text-uppercase text-secondary">Password</label>
              <div className="input-group">
                <span className="input-group-text bg-light text-secondary">
                  <i className="bi bi-lock"></i>
                </span>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
            </div>

            <button type="submit" className="btn btn-primary w-100 py-2 fw-bold shadow-sm" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Signing In...
                </>
              ) : (
                <>
                  <i className="bi bi-box-arrow-in-right me-2"></i> Sign In
                </>
              )}
            </button>
          </form>

          {/* COMPANY FOOTER DETAILS */}
          <div className="mt-4 pt-3 border-top text-center text-muted small">
            <div className="fw-semibold text-dark mb-1">{compName}</div>
            <div className="text-muted" style={{ fontSize: '0.75rem' }}>
              {compAddress} &bull; <i className="bi bi-telephone-fill"></i> {compContact}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
